import axios from 'axios'
import request from "@/utils/request";

// 获取轮播图列表
export function image(params) {
  return request({
    //url: "http://mall.5baiwan.top/api/file/upload/image",
    url: "/api/file/upload/image",
    method: "post",
    data: params
  });
}

export function uploadFile(params) {
  return request({
    url: "/api/file/upload/resource",
    method: "post",
    data: params
  });
}

//文件上传
// 获取轮播图列表
export function uploadimage(params) {
  let par = new FormData()
  par.append('file', params)
  return request({
    //url: "http://mall.5baiwan.top/api/file/upload/image",
    url: "/api/file/upload/image",
    method: "post",
    data: par,
    headers: { //添加请求头
        'Content-Type': 'multipart/form-data'
    }
  });
}

export function downloadFile(name) {
  return axios({
    //url: 'http://mall.5baiwan.top/api/file/download/' + name,
    url: process.env.BASE_API + '/api/file/download/' + name,
    timeout: 30000, // 请求超时时间10s
    method:'get',
    headers: { //添加请求头
      'Authorization': localStorage.getItem("Authorization")
    },
    responseType: 'arraybuffer',
  });
}



// WEBPACK FOOTER //
// ./src/api/file.js